export const title = (page) => `Cooked As - ${page}`
